import React from "react";
import { iconProps } from "../../Helper";

const TextToVideoIcon = ({className}:iconProps) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_13038_279"
        style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="16"
      >
        <rect x="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13038_279)">
        <path
          className={className}
          d="M3.37184 13C3.03506 13 2.75001 12.8833 2.51667 12.65C2.28334 12.4167 2.16667 12.1316 2.16667 11.7948V4.20517C2.16667 3.86839 2.28334 3.58333 2.51667 3.35C2.75001 3.11667 3.03506 3 3.37184 3L4.53851 5.33333H6.53851L5.37184 3H6.70517L7.87184 5.33333H9.87184L8.70517 3H10.0385L11.2052 5.33333H13.2052L12.0385 3H13.6282C13.965 3 14.25 3.11667 14.4833 3.35C14.7167 3.58333 14.8333 3.86839 14.8333 4.20517V6.609H13.8333V6.33333H3.16667V11.7948C3.16667 11.8547 3.18589 11.9039 3.22434 11.9423C3.26278 11.9808 3.31195 12 3.37184 12H8.44867V13H3.37184ZM9.91034 13.6667V11.9052L13.5295 8.3025C13.6124 8.21961 13.7021 8.16128 13.7987 8.1275C13.8952 8.09383 13.9918 8.077 14.0885 8.077C14.1918 8.077 14.2929 8.09661 14.3917 8.13583C14.4903 8.17517 14.579 8.23417 14.6577 8.31283L15.2743 8.93583C15.3461 9.01883 15.4017 9.10861 15.441 9.20517C15.4803 9.30172 15.5 9.39828 15.5 9.49483C15.5 9.59139 15.4821 9.68967 15.4462 9.78967C15.4103 9.88967 15.353 9.98111 15.2743 10.064L11.6718 13.6667H9.91034ZM10.7052 12.8718H11.3385L13.5025 10.6973L13.1962 10.3807L12.8858 10.068L10.7052 12.2385V12.8718ZM13.1962 10.3807L12.8858 10.068L13.5025 10.6973L13.1962 10.3807Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default TextToVideoIcon;
